import React, { useState } from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import SBoxTable from "./sbox";

const Verify = ({
  allEncResults,
  setVerificationState,
  incrementRoundAndCounter,
  decrementRoundAndCounter,
}) => {
  const [inputs, setInputs] = useState(["", "", "", ""]);
  const [input1, setInput1] = useState("");
  const [verificationResult, setVerificationResult] = useState("");
  let round = 3;

  const handleVerify = () => {
    if (input1.toLowerCase() === allEncResults[2][round - 1][3].join(" ")) {
      setVerificationResult("Verification successful! Click on Next again");
      setVerificationState(true);
      incrementRoundAndCounter();
    } else {
      setVerificationResult("Verification failed. Try again.");
    }
  };

  const transposedData1 = allEncResults[4][round - 2].map((col, columnIndex) =>
    allEncResults[4][round - 2].map((row) => row[columnIndex])
  );

  const sBoxData = [
    [
      "52", "09", "6a", "d5", "30", "36", "a5", "38", "bf", "40", "a3", "9e", "81", "f3", "d7", "fb",
    ],
    [
      "7c", "e3", "39", "82", "9b", "2f", "ff", "87", "34", "8e", "43", "44", "c4", "de", "e9", "cb",
    ],
    [
      "54", "7b", "94", "32", "a6", "c2", "23", "3d", "ee", "4c", "95", "0b", "42", "fa", "c3", "4e",
    ],
    [
      "08", "2e", "a1", "66", "28", "d9", "24", "b2", "76", "5b", "a2", "49", "6d", "8b", "d1", "25",
    ],
    [
      "72", "f8", "f6", "64", "86", "68", "98", "16", "d4", "a4", "5c", "cc", "5d", "65", "b6", "92",
    ],
    [
      "6c", "70", "48", "50", "fd", "ed", "b9", "da", "5e", "15", "46", "57", "a7", "8d", "9d", "84",
    ],
    [
      "90", "d8", "ab", "00", "8c", "bc", "d3", "0a", "f7", "e4", "58", "05", "b8", "b3", "45", "06",
    ],
    [
      "d0", "2c", "1e", "8f", "ca", "3f", "0f", "02", "c1", "af", "bd", "03", "01", "13", "8a", "6b",
    ],
    [
      "3a", "91", "11", "41", "4f", "67", "dc", "ea", "97", "f2", "cf", "ce", "f0", "b4", "e6", "73",
    ],
    [
      "96", "ac", "74", "22", "e7", "ad", "35", "85", "e2", "f9", "37", "e8", "1c", "75", "df", "6e",
    ],
    [
      "47", "f1", "1a", "71", "1d", "29", "c5", "89", "6f", "b7", "62", "0e", "aa", "18", "be", "1b",
    ],
    [
      "fc", "56", "3e", "4b", "c6", "d2", "79", "20", "9a", "db", "c0", "fe", "78", "cd", "5a", "f4",
    ],
    [
      "1f", "dd", "a8", "33", "88", "07", "c7", "31", "b1", "12", "10", "59", "27", "80", "ec", "5f",
    ],
    [
      "60", "51", "7f", "a9", "19", "b5", "4a", "0d", "2d", "e5", "7a", "9f", "93", "c9", "9c", "ef",
    ],
    [
      "a0", "e0", "3b", "4d", "ae", "2a", "f5", "b0", "c8", "eb", "bb", "3c", "83", "53", "99", "61",
    ],
    [
      "17", "2b", "04", "7e", "ba", "77", "d6", "26", "e1", "69", "14", "63", "55", "21", "0c", "7d",
    ]
  ];

  const icon = {
    hidden: {
      x: -700,
    },
    visible: {
      x: 0,
      transition: {
        delay: 0.25,
        duration: 1,
      },
    },
  };

  let data = allEncResults[1][round - 1].toString().split(" ");
  console.log("data", data);

  let cols2 = [
    [data.slice(0, 4)],
    [data.slice(4, 8)],
    [data.slice(8, 12)],
    [data.slice(12, 16)],
  ];

  const renderTable2 = () => {
    const table = [];

    for (let i = 0; i < 4; i++) {
      const row = [];
      for (let j = 0; j < 4; j++) {
        row.push(
          <td key={j} className="px-6 py-4 whitespace-nowrap">
            <div className="text-sm text-gray-900">{cols2[j][0][i]}</div>
          </td>
        );
      }
      table.push(<tr key={i}>{row}</tr>);
    }

    return table;
  };

  return (
    <>
      <div className="bg-gray-100 p-4 rounded-md shadow-md">
        <h2 className="text-2xl font-semibold mb-4">Verification of Round 3</h2>
        <p className="pb-5">
          Now calculate the following Values for Round 3 and enter it below (It
          should be the hex values with spaces)
        </p>

        <div className="grid grid-flow-col grid-cols-5 gap-2 align-middle pt-28">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 2 }}
            className="w-fit"
          >
            <table className="bg-emerald-100 rounded-xl w-auto border hover:border-cyan-500">
              <tbody>
                {/* Map through the transposed data and create rows for each column */}
                {transposedData1.map((column, columnIndex) => (
                  <tr key={columnIndex}>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">
                        {/* Join the characters in each item and display in a single row */}
                        {column
                          .map((item) => item.split("").join(""))
                          .join(" \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 ")}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p className="align-middle">
              {" "}
              After XOR(Final o/p of Previous round)
            </p>
          </motion.div>

          <div className=" pt-20 pl-7">
            <svg
              width="170"
              height="38"
              viewBox="0 0 573 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <motion.path
                variants={icon}
                initial="hidden"
                animate="visible"
                d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                fill="black"
              />
            </svg>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 2 }}
            className="w-fit"
          >
            <table className=" bg-emerald-100 rounded-xl w-auto">
              <tbody className="">{renderTable2()}</tbody>
            </table>
            <p className="align-middle"> After S-box substition</p>
          </motion.div>

          <div className=" pt-20 pl-7">
            <svg
              width="170"
              height="38"
              viewBox="0 0 573 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <motion.path
                variants={icon}
                initial="hidden"
                animate="visible"
                d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                fill="black"
              />
            </svg>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 2 }}
            className="w-fit"
          >
            <table className=" bg-emerald-100 rounded-xl w-auto">
              <tbody className="">
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900 ">
                      {allEncResults[2][round - 1][0]
                        .map((item) => item.split("").join(""))
                        .join(" \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0")}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {allEncResults[2][round - 1][1]
                      .map((item) => item.split("").join(""))
                      .join(" \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0")
                      .slice(0, 25)}

                    {allEncResults[2][round - 1][1]
                      .map((item) => item.split("").join(""))
                      .join(" ")
                      .slice(9, 13)}
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {allEncResults[2][round - 1][2]
                      .map((item) => item.split("").join(""))
                      .join(" \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0")
                      .slice(0, 15)}
                    {allEncResults[2][round - 1][2]
                      .map((item) => item.split("").join(""))
                      .join("\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0")
                      .slice(15, 26)}
                  </td>
                </tr>
                <tr>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {/* <div className="text-sm text-gray-900">{allEncResults[2][round-1][3].map(item => item.split('').join('')).join(' \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0')}</div> */}
                    <input
                      type="text"
                      value={input1}
                      onChange={(e) => setInput1(e.target.value)}
                    ></input>
                  </td>
                </tr>
              </tbody>
            </table>
            <p className="align-middle"> After Shifted Rows</p>
          </motion.div>
        </div>

        <div className="next-button" onClick={handleVerify}>
          NEXT
        </div>

        {/* <div className="button-holder">
        <div className="prev-button" onClick={decrementRoundAndCounter}>
          PREVIOUS
        </div>
        <div className="next-button" onClick={handleVerify}>
          NEXT
        </div>
      </div> */}
        <p className="mt-2">{verificationResult}</p>
      </div>
      <div className="grid grid-cols-3 gap-8 content-center pt-4 px-4">
        <div></div>
      </div>
    </>
  );
};

export default Verify;
